module.exports = __webpack_public_path__ + "img/screenshot-posting.5d1ea5a6.png";